import { connect } from 'react-redux'
import  FeedbackPage  from '../components/FeedbackPage'
import { newPlan } from '../actions/plan'
import { sendFeedBack, updateFeedback } from '../actions/feedBack.js'


const mapStateToProps = (state, ownProps) => {
    return {
        sendingPlan: state.planService.isSaving && state.plan.sent === true,
        notConnected: state.planService.notConnected,
        feedbackSent: state.plan.feedbackSent
    }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
    onFeedbackSubmit: (values) => {
        dispatch(updateFeedback(values));
        dispatch(sendFeedBack());
    },
    onNewPlanClick: () => {
        dispatch(newPlan());
    } 
})




const FeedbackContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(FeedbackPage)

export default FeedbackContainer